/* import __COLOCATED_TEMPLATE__ from './pix-multi-select.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { warn } from '@ember/debug';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
function sortOptionsByCheckedFirst(a, b) {
  if (a.checked && b.checked) return 0;
  if (a.checked) return -1;
  if (b.checked) return 1;
  return 0;
}
function removeCapitalizeAndDiacritics(string) {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}
let PixMultiSelect = (_class = class PixMultiSelect extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isExpanded", _descriptor, this);
    _initializerDefineProperty(this, "searchData", _descriptor2, this);
    warn(`PixMultiSelect: @strictSearch is deprecated in favour of @onSearch`, !this.args.strictSearch, {
      id: 'pix-ui.pix-multi-select.strictSearch.deprecated'
    });
  }
  get options() {
    return [...(this.args.options || [])];
  }
  get hasValues() {
    return this.args.values && Array.isArray(this.args.values);
  }
  get displayedOptions() {
    const optionsWithCheckedStatus = this.options.map(option => ({
      ...option,
      checked: this.hasValues ? this.args.values.includes(option.value) : false
    }));
    if (this.args.isSearchable) {
      return [...optionsWithCheckedStatus.sort(sortOptionsByCheckedFirst)];
    }
    return optionsWithCheckedStatus;
  }
  get mainInputClassName() {
    let classes = 'pix-multi-select-main-input';
    if (this.args.isSearchable) {
      classes += ' pix-multi-select-main-input--is-searchable';
    }
    if (this.args.className) {
      classes += ` ${this.args.className}`;
    }
    return classes;
  }
  get multiSelectId() {
    if (this.args.id) return this.args.id;
    return 'select-' + guidFor(this);
  }
  get listId() {
    return `list-${this.multiSelectId}`;
  }
  get isAriaExpanded() {
    return this.isExpanded ? 'true' : 'false';
  }
  get results() {
    if (this.args.isSearchable && this.searchData) {
      return this.displayedOptions.filter(({
        label
      }) => this._search(label));
    }
    return this.displayedOptions;
  }
  get placeholder() {
    const {
      values,
      placeholder
    } = this.args;
    if (values?.length > 0) {
      const selectedOptionLabels = this.options.filter(option => {
        const hasOption = values.includes(option.value);
        return hasOption && Boolean(option.label);
      }).map(({
        label
      }) => label).join(', ');
      return selectedOptionLabels;
    }
    return placeholder;
  }
  _search(label) {
    if (this.args.strictSearch) {
      return label.includes(this.searchData);
    }
    return removeCapitalizeAndDiacritics(label).includes(this.searchData);
  }
  onSelect(event) {
    let selected = [...(this.args.values || [])];
    if (event.target.checked) {
      selected.push(event.target.value);
    } else {
      selected = selected.filter(value => value !== event.target.value);
    }
    if (this.args.onChange) {
      this.args.onChange(selected);
    }
  }
  toggleDropDown() {
    if (this.isExpanded) {
      this.hideDropDown();
    } else {
      this.showDropDown();
    }
  }
  showDropDown() {
    if (this.isExpanded) return;
    this.isExpanded = true;
  }
  hideDropDown(event) {
    if (!this.isExpanded) return;
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.isExpanded = false;
  }
  updateSearch(event) {
    if (this.args.onSearch) {
      this.args.onSearch(event.target.value);
    } else {
      this.searchData = this.args.strictSearch ? event.target.value : removeCapitalizeAndDiacritics(event.target.value);
    }
    this.isExpanded = true;
  }
  get className() {
    const {
      className
    } = this.args;
    return ' ' + className;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "searchData", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onSelect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleDropDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleDropDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDropDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showDropDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDropDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hideDropDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSearch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSearch"), _class.prototype), _class);
export { PixMultiSelect as default };